import { Card, Skeleton, Stack, Typography } from '@mui/material';
import { a, useTrail } from '@react-spring/web';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import instance from '../../api/axiosRequest';

export default function TemplateList() {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getTemplates = async () => {
      try {
        setLoading(true);
        const { data } = await instance.get('/vendor/emailTemplates');
        setTemplates(data.data.rows);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    };
    getTemplates();
  }, []);

  const trail = useTrail(templates.length, {
    config: { mass: 5, tension: 2000, friction: 200 },
    opacity: 1,
    x: 0,
    from: { opacity: 0, x: 20 },
  });

  return (
    <Card sx={{ p: 2, mt: 2 }}>
      {loading ? (
        <Skeleton />
      ) : (
        <Stack direction="row" flexWrap="wrap">
          {trail.map(({ ...style }, index) => (
            <a.div
              style={style}
              key={index}
              onClick={() =>
                navigate(`/dashboard/campaigns/email-templates/custom?name=${templates[index].template}`)
              }
            >
              <Card sx={{ width: 240, mb: 2, p: 2, mr: 6 }}>
                <Typography textAlign="center">{templates[index].template}</Typography>
              </Card>
            </a.div>
          ))}
        </Stack>
      )}
    </Card>
  );
}
